import { AUTH_TOKEN_COOKIE, OLD_AUTH_COOKIE } from "@/types/auth"
import { InitChatProps } from "@/types/chat"
import { Budget } from "@/types/trip"

export const EmbeddedParamNames = [
  "embedded",
  OLD_AUTH_COOKIE,
  AUTH_TOKEN_COOKIE,
  "orgid",
  "orgurl",
  "geoname",
] as const

export type EmbeddedParamName = (typeof EmbeddedParamNames)[number]

export interface EmbeddedProps extends EmbeddedFrameProps {
  orgid?: string
  orgUrl?: string
  geoName?: string
  route?: string
  open?: boolean
  code?: string // Capital One SSO authorization code
}

export type EmbeddedFrameProps = {
  prompt?: string
  intro?: string
  button?: string
  link?: string
  hint?: string
  start?: string
  destination?: string
  dates?: string
  budget?: Budget
  vibes?: string[]
  locale?: string
  nocookie?: string // deny list of cookie types
  id?: string // "default" for click on Ask AI tab
  preview?: boolean
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  nkid?: string // News Corp partner visitor id
  click_ids?: string // ad click ids from host page, e.g. "fbclid=...&gclid=..."
  open_trigger?: "cta" | "launcher" | "api" | "url_param" | "url_hash"
  host_referrer?: string // host page's document.referrer (origin + path), url_* opens only
}

export type InitEmbeddedChatProps = InitChatProps & EmbeddedFrameProps
